import React, { useContext, useState } from "react";
import { useMutation } from "@tanstack/react-query";

//App
import { LookupValueFormContainerProps } from "../../../../types/lookupValue";
import { SnackbarState } from "../../../../types";
import { LookupValueDto } from "../../../../app/model/api/types/dto";
import lookupValueApi from "../../../../app/model/api/lookupValueApi";
import { apiErrorMessage } from "../../../../utility/lib/error";
import { LookupValueViewModel } from "../../../../viewModels";
import { LookupValueContext } from "./LookupValueContainer";
import { EMPTY_GUID } from "../../../../utility/constants";
import LookupValueForm from "./LookupValueForm";

//Common
import Snackbar from "../../../common/VFX-UI/SnackBar/Snackbar";

export const LookupValueFormContainer: React.FC<
  LookupValueFormContainerProps
> = (props) => {
  const { onClose, onShowSuccess } = props;
  const lookupValueContext = useContext(LookupValueContext);

  const [snackbar, setSnackbar] = useState<SnackbarState>({
    showErrorSnackbar: false,
    errorMessage: "",
  });

  const successMessage = lookupValueContext?.id
    ? `${lookupValueContext?.lookupType?.name} updated`
    : `New ${lookupValueContext?.lookupType?.name} added`;

  const onShowErrorSnackbar = (errorMessage: string) =>
    setSnackbar({
      showErrorSnackbar: true,
      errorMessage,
    });

  const onCloseSnackbar = () =>
    setSnackbar({
      showErrorSnackbar: false,
      errorMessage: "",
    });

  const { status, mutate } = useMutation<void, Error, LookupValueDto>({
    mutationFn: async (payload: LookupValueDto) => {
      const response = await lookupValueApi.save(payload);
      const errorMessage = apiErrorMessage(response.errorMessages);
      if (errorMessage) {
        onShowErrorSnackbar(errorMessage);
      } else {
        onShowSuccess(successMessage);
      }
    },
  });

  const handleOnSubmit = async (values: LookupValueViewModel) => {
    const county: LookupValueDto = values.toDto();
    mutate(county);
  };

  let lookupTypeId =
    lookupValueContext?.lookupTypeId !== null &&
    lookupValueContext?.lookupTypeId !== undefined
      ? [lookupValueContext.lookupTypeId]
      : [];

  const initialValues = lookupValueContext?.id
    ? new LookupValueViewModel(
        lookupValueContext.data?.id ?? null,
        lookupValueContext.data?.name ?? null,
        lookupValueContext.data?.description ?? null,
        lookupValueContext.data?.typeId !== null &&
        lookupValueContext.data?.typeId !== undefined
          ? [lookupValueContext.data?.typeId]
          : null,
        lookupValueContext.data?.groupId !== null &&
        lookupValueContext.data?.groupId !== undefined
          ? [lookupValueContext.data?.groupId]
          : null,
        lookupValueContext.data?.sortValue ?? null,
        lookupValueContext.data?.isActive ?? null
      )
    : new LookupValueViewModel(
        EMPTY_GUID,
        "",
        "",
        lookupTypeId,
        null,
        100,
        true
      );

  return (
    <>
      <LookupValueForm
        initialVal={initialValues}
        status={status}
        handleOnSubmit={handleOnSubmit}
        onClose={onClose}
      />
      {snackbar.showErrorSnackbar && (
        <Snackbar
          open={true}
          message={snackbar.errorMessage}
          handleClose={onCloseSnackbar}
          severity="danger"
        />
      )}
    </>
  );
};
